/* Segway modeloverzicht: filtert de kaarten op categorie. Zonder JavaScript blijven alle modellen zichtbaar.
   De categorie kan ook uit de link komen, bijvoorbeeld /pages/modellen?categorie=atv */
if (!customElements.get('segway-model-filter')) {
  class SegwayModelFilter extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-cat]'));
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.apply(chip.dataset.filter, true));
      });

      let wanted = null;
      try {
        wanted = new URLSearchParams(window.location.search).get('categorie');
      } catch (e) {
        wanted = null;
      }
      if (wanted && this.chips.some((chip) => chip.dataset.filter === wanted)) {
        this.apply(wanted, false);
      }
    }

    apply(filter, updateUrl) {
      this.chips.forEach((chip) => {
        const active = chip.dataset.filter === filter;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      this.cards.forEach((card) => {
        card.hidden = !(filter === 'all' || card.dataset.cat === filter);
      });
      if (updateUrl && window.history && window.history.replaceState) {
        try {
          const url = new URL(window.location.href);
          if (filter === 'all') url.searchParams.delete('categorie');
          else url.searchParams.set('categorie', filter);
          window.history.replaceState(null, '', url.toString());
        } catch (e) {
          /* de filter werkt ook zonder aangepaste link */
        }
      }
    }
  }

  customElements.define('segway-model-filter', SegwayModelFilter);
}
